import React, { Component } from "react";

const SectionHeader = ({ title }) => (
  <>
    <h4 className="rti-panel-title">{title}</h4>
    <div className="rti-panel-rule" />
  </>
);

const EmptyState = ({ message }) => (
  <div className="rti-empty">
    <span className="rti-empty-icon fa fa-file-text-o" aria-hidden="true" />
    <h6>Information will be published soon</h6>
    <p>{message}</p>
  </div>
);

class RtiDescription extends Component {
  render() {
    const { type } = this.props;
    return (
      <div>
        {type === "home" && <History title="RIGHT TO INFORMATION (RTI)" />}
        {type === "officers" && <Officers title="INFORMATION OFFICERS" />}
        {type === "ief" && <Ief title="INFORMATION IN ELECTRONIC FORM" />}
        {type === "pac" && (
          <Pac title="PARTICULARS AVAILABLE TO THE CITIZENS" />
        )}
      </div>
    );
  }
}

export default RtiDescription;

const particulars = [
  ["Name of the Institution", "Dispur College (Higher Education Institution)"],
  ["Year of Establishment", "1978"],
  ["Address", "Ganeshguri, Dispur, Guwahati, Assam – 781016"],
  ["Telephone Number", "0361-3513202 / 0361-3615332"],
  ["Email Id", "dispurcollege1978@gmail.com"],
  ["Website", "www.dispurcollege.ac.in"],
  [
    "Nature of the Institution",
    "Government (Provincialized). Recognised under Section 2(f) and 12B of the UGC Act.",
  ],
  [
    "Institutional Affiliation",
    "Affiliated to Gauhati University and follows the CBCS curriculum of the University at the UG level.",
  ],
  ["Streams", "Arts, Commerce and Professional Courses (BBA & BCA)"],
  ["Number of Departments", "10"],
  ["Courses Offered", "B.A., B.Com, B.B.A. and B.C.A."],
  ["NAAC Accreditation", "Grade B (2.13 CGPA), 2015"],
];

export const History = (props) => (
  <div>
    <SectionHeader title={props.title} />
    <div className="rti-body">
      <p>
        Statutory declaration under Section 4(1)(b) of the Right to Information
        Act, 2005.
      </p>

      <h5>Particulars of the Institution</h5>
      <table className="rti-table rti-table--kv">
        <tbody>
          {particulars.map(([label, value], i) => (
            <tr key={i}>
              <td>{label}</td>
              <td>{value}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <h5>Functions and Duties of the Institution</h5>
      <p>
        Dispur College is a premier higher education institution committed to
        delivering quality education for all. The College is affiliated to
        Gauhati University and adheres to all the academic curricula of the
        University at the UG level. All faculty members perform their teaching
        duties and other responsibilities with due diligence as per the norms
        prescribed in the UGC regulations, and the rules and regulations framed
        by the State and Union Governments along with the regulating
        authorities.
      </p>

      <h5>RTI and Information Delivery System of the Institution</h5>
      <p>
        Dispur College, being a Government-funded public institution, is subject
        to the RTI Act, 2005. To ensure transparency and accountability, the
        College has put in place a proper information delivery mechanism. One of
        the senior-most faculty members (Associate Professor) of the College
        acts as the Public Information Officer (PIO). In this capacity, the PIO
        receives all types of RTI applications, registers the matter in the RTI
        log book, and seeks information from the concerned department or section
        of the College as the case may be, ensuring a timely reply to every RTI
        query.
      </p>
    </div>
  </div>
);

const statutoryOfficers = [
  {
    designation: "First Appellate Authority (FAA)",
    name: "Dr. Navajyoti Borah, Principal",
    contact: "dispurcollege1978@gmail.com",
    role: "Decides on appeals if the applicant is dissatisfied with the PIO's response under Sec 19(1).",
  },
  {
    designation: "Public Information Officer (PIO)",
    name: "Mrs. Indrani C. Mahanta, Vice-Principal",
    contact: "—",
    role: "Responsible for receiving applications and providing the requested information under Sec 5(1).",
  },
  {
    designation: "Asst. PIO (APIO)",
    name: "Rimli Hazarika (Non-teaching Member)",
    contact: "—",
    role: "Receives applications/appeals to forward to the PIO or FAA under Sec 5(2).",
  },
];

export const Officers = (props) => (
  <div>
    <SectionHeader title={props.title} />
    <div className="rti-body">
      <h5>RTI Cell</h5>
      <div className="rti-callout">
        <strong>Objective:</strong> To provide a transparent and accountable
        administrative system and to ensure the right of citizens to secure
        access to information under the control of public authorities as per the
        RTI Act, 2005.
        <br />
        <strong>Functions:</strong>
        <ul>
          <li>
            To receive and process RTI applications within prescribed time
            limits (30 days for standard requests; 48 hours for life/liberty
            cases).
          </li>
          <li>
            To ensure proactive disclosure of institutional information as per
            Section 4(1)(b).
          </li>
          <li>
            To provide information or valid rejection orders under Sections 8, 9,
            or 11.
          </li>
          <li>
            To maintain the RTI Register (Application, Disposal, and Appeal
            logs).
          </li>
        </ul>
      </div>

      <h5>I. Statutory Officers</h5>
      <table className="rti-table rti-table--grid">
        <thead>
          <tr>
            <td style={{color: "white"}}>Designation</td>
            <td>Name &amp; Post</td>
            <td>Contact Details</td>
            <td>Role</td>
          </tr>
        </thead>
        <tbody>
          {statutoryOfficers.map((o, i) => (
            <tr key={i}>
              <td>{o.designation}</td>
              <td>{o.name}</td>
              <td>{o.contact}</td>
              <td>{o.role}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <h5>II. RTI Assistance Committee (Deemed PIOs)</h5>
      <p>
        The following members shall provide assistance to the PIO under Section
        5(4) of the RTI Act. Any officer whose assistance is sought shall be
        treated as a &ldquo;Deemed PIO&rdquo; and shall be liable for any
        contravention of the Act.
      </p>
      <ol style={{ paddingLeft: "1.2rem" }}>
        <li>Mrs. Indrani C. Mahanta</li>
        <li>Dr. Sashi Mohan Das</li>
        <li>Dr. Mathur Barman</li>
      </ol>
    </div>
  </div>
);

export const Ief = (props) => (
  <div>
    <SectionHeader title={props.title} />
    <EmptyState message="Information available in electronic form at the college office will be listed here." />
  </div>
);

export const Pac = (props) => (
  <div>
    <SectionHeader title={props.title} />
    <EmptyState message="The particulars of facilities available to citizens for obtaining information during the working hours of the college will be listed here." />
  </div>
);
